import { memo } from 'react';

function MenuCard() {
  return null;
}

export default memo(MenuCard);